import { Flex, Text } from '@backstage/ui';
import { getComplianceColorVar } from '@internal/backstage-plugin-pulse-common';

/**
 * Percentage + single-color animated fill bar, matching the Insights table
 * compliance column visual. The bar color reflects the compliance threshold.
 */
export const CompliancePercentageBar = ({
  percentage,
}: {
  percentage: number;
}) => (
  <Flex align="center" gap="2">
    <Text variant="body-small" weight="bold">
      {percentage === 100 ? '100' : percentage.toFixed(1)}%
    </Text>
    <div
      style={{
        flex: 1,
        height: '6px',
        background: 'var(--bui-bg-neutral-2)',
        borderRadius: 'var(--bui-radius-2)',
        overflow: 'hidden',
        minWidth: '80px',
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${percentage}%`,
          background: getComplianceColorVar(percentage),
          transition: 'width 0.3s ease',
        }}
      />
    </div>
  </Flex>
);

/**
 * Horizontal pass/fail bar: a green segment sized to the passing fraction
 * followed by a red segment for the remainder.
 */
export const ComplianceBar = ({
  passed,
  total,
}: {
  passed: number;
  total: number;
}) => {
  const passedFraction = total > 0 ? (passed / total) * 100 : 0;
  return (
    <div
      style={{
        display: 'flex',
        height: '8px',
        width: '100%',
        minWidth: '80px',
        borderRadius: 'var(--bui-radius-2)',
        overflow: 'hidden',
        backgroundColor: 'var(--bui-bg-neutral-2)',
      }}
    >
      <div
        style={{
          width: `${passedFraction}%`,
          backgroundColor: 'var(--bui-fg-positive)',
        }}
      />
      <div
        style={{
          width: `${100 - passedFraction}%`,
          backgroundColor: 'var(--bui-fg-negative)',
        }}
      />
    </div>
  );
};
